export const usage = [
    '1. On the landing page, there are 3 buttons. “Information” gives the importance of the system, “How to Use” gives the usage instructions, and to use the system click “Let’s Start”.',
    '2. Select what sign you want to replicate from the dropdown menu at the top-middle of the page. Then click “Start Pose”.',
    '3. When the app asks for permission for the camera, allow it access to capture hand gestures.',
    '4. See the image of the pose on the right side and replicate that image in front of the camera.',
    '5. If you do that correctly the points over the video will become green in color.',
    '6. To select another sign, click “Stop Pose” and select another from the dropdown menu.'
]

export const fixCamera = [
    'Solution 1. Make sure you have allowed the permission of camera, if you have denined the permission, go to setting of your browser to allow the access of camera to the application.',
    'Solution 2. Make sure no any other application is not accessing camera at that time, if yes, close that application',
    'Solution 3. Try to close all the other opened broswers'
] 
